import axios from 'axios'

const API_URL = process.env.REACT_APP_BASE_API_URL
const GET_GOVT_ID_TYPES = `${API_URL}/ref-data?group=govtIssuedIdTypes`
const CREATE_TEAM_MEMBER = `${API_URL}/stakeholders/management-teams`
const GET_ALL_TEAM_MANAGEMENT=`${API_URL}/stakeholders/management-teams`
const GET_DROPDOWN_DATA=`${API_URL}/stakeholders/individuals`

export const getGovtIdTypes = (type: string, companyId: number) => {
  return axios.get(`${GET_GOVT_ID_TYPES}&type=${type}`, {
    headers: {
      'x-company-id': companyId,
    },
    validateStatus(status) {
      return true
    },
  })
}

  export const createTeamMangement = (payload: any, companyId: number) => {
    return axios.post(`${CREATE_TEAM_MEMBER}`, payload, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getDropDownData = (companyId: number) => {
    return axios.get(`${GET_DROPDOWN_DATA}`, {
      headers: {
        'x-company-id': companyId,
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getTeamManagement = (
    companyId: number,
    page: number,
    pageSize: number,
    sortBy?: string
  ) => {
    return axios.get(
      `${GET_ALL_TEAM_MANAGEMENT}?page=${page}&pageSize=${pageSize}${
        sortBy ? `&sortBy=${sortBy}` : ''
      }`,
      {
        headers: {
          'x-company-id': companyId,
        },
        validateStatus(status) {
          return true
        },
      }
    )
  }

  export const importTeamManagement = (data: any, companyId: number) => {
    return axios.post(`${CREATE_TEAM_MEMBER}/csv/import`, {managementTeams: data}, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const exportTeamManagement = (companyId: number) => {
    return axios.get(`${CREATE_TEAM_MEMBER}/csv/export`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getTeamManagementStatistics = (companyId: number) => {
    return axios.get(`${CREATE_TEAM_MEMBER}/statistics`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const getTeamMemberDetails = (memberId: string, companyId: number) => {
    return axios.get(`${CREATE_TEAM_MEMBER}/${memberId}`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const updateTeamMember = (
    payload: any,
    companyId: number,
    memberId: string
  ) => {
    return axios.post(`${CREATE_TEAM_MEMBER}/${memberId}`, payload, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }

  export const deleteTeamMember = (memberId: string, companyId: number) => {
    return axios.delete(`${CREATE_TEAM_MEMBER}/${memberId}`, {
      headers: {
        'x-company-id': companyId.toString(),
      },
      validateStatus(status) {
        return true
      },
    })
  }
